export class UserRoutes {
    public Login = true;
    public Logout = true;
    public Dashboard = true;
    public AccountClosed = false;
    public AccountSuspended = false;
    public ForgotPassword = false;
    public ResetPassword = false;
    public ShipmentHistory = false;
    public BillingHistory = false;
    public RecentShipment = false;
    public ReportHistory = false;
    public SchedulePickup = false;
    public SavedQuotes = false;
    public ManageLocations = false;
    public AddressBook = false;
    public UserSettings = false;
    public PackageInvestigation = false;
    public CompanyProfile = false;
    public SupplyOrder = false;
    public PaymentHistory = false;
    public ManageCreditCard = false;
    public CreditHistory = false;
    public AddCreditCard = false;
    public RewardShip = false;
    public AddCreditCardBounce = false;
    public WorldShipUpload = false;
    public Claims = false;
    public ClaimFAQ = false;
    public FileClaim = false;
    public ClaimsDashboard = false;
    public DeliveryDefenseFAQ = false;
    public DeliveryDefenseSignUp = false;
    public ShippingIntelligence = false;
    public ScoreHistory = false;
    public AddressConfidenceTool = false;
    public ManageSubscriptions = false;
    public Support = false;
    public Reports = false;
    public Terms = false;
    public EndOfDayReports = false;
    public Ship = false;
    public ShipUPS = false;
    public ShipFedex = false;
    public ShipReport = false;
    public BIR = false;
    public ManageUsers = false;
    public CostEstimator = false;
    public Shipments = false;
    public NotifyTemplates = false;
    public AccessDenied = false;
    public Maintenance = false;
    public ContactUs = false;
    public FAQs = false;
    public RestrictedZipCodes = true;
    public TermsUnsigned = false;
    public SupportDocuments = false;
    public OrderSuppliesHistory = true;
    public DWRewardShip = false;
    public TrackShipments = false;
    public ECommerce = false;
}
